/**
 * One colour per expense category, everywhere a category is shown.
 *
 * Categories are user-defined, so a fixed map cannot cover them all. Common
 * names get hand-picked colours; anything else falls back to a hash of the
 * name, so "Milk" is the same colour on every page and every reload.
 *
 * Tailwind's scanner only sees literal class strings, which is why every
 * class here is written out in full - never build these by interpolation.
 */
const PALETTE = [
  { dot: 'bg-emerald-500', soft: 'bg-emerald-50', text: 'text-emerald-700' },
  { dot: 'bg-blue-500', soft: 'bg-blue-50', text: 'text-blue-700' },
  { dot: 'bg-violet-500', soft: 'bg-violet-50', text: 'text-violet-700' },
  { dot: 'bg-amber-500', soft: 'bg-amber-50', text: 'text-amber-700' },
  { dot: 'bg-rose-500', soft: 'bg-rose-50', text: 'text-rose-700' },
  { dot: 'bg-cyan-500', soft: 'bg-cyan-50', text: 'text-cyan-700' },
  { dot: 'bg-orange-500', soft: 'bg-orange-50', text: 'text-orange-700' },
  { dot: 'bg-teal-500', soft: 'bg-teal-50', text: 'text-teal-700' },
];

const PRESETS = {
  food: 0,
  groceries: 0,
  rent: 1,
  salary: 2,
  'staff salary': 2,
  staff: 2,
  utilities: 3,
  utility: 3,
  electricity: 3,
  water: 3,
  supplies: 5,
  'office supplies': 5,
  'raw materials': 5,
  marketing: 4,
  travel: 6,
  transport: 6,
  maintenance: 7,
  repair: 7,
};

const NEUTRAL = { dot: 'bg-gray-400', soft: 'bg-gray-50', text: 'text-gray-600' };

export function categoryColor(name) {
  const key = (name || '').trim().toLowerCase();

  if (!key || key === 'other' || key === 'uncategorized') {
    return NEUTRAL;
  }

  const preset = PRESETS[key];
  if (preset !== undefined) {
    return PALETTE[preset];
  }

  // djb2 - stable across runs, so a custom category keeps its colour forever
  let hash = 5381;
  for (let i = 0; i < key.length; i += 1) {
    hash = ((hash * 33) ^ key.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}
